class SireEmailPopup extends HTMLElement {
  connectedCallback() {
    if (this.controller) return;
    this.controller = new AbortController();
    const { signal } = this.controller;
    const dialog = this.querySelector('dialog');
    if (!dialog?.showModal) return;
    const key = 'sire-email-popup-v1';
    const read = () => { try { return JSON.parse(localStorage.getItem(key) || '{}'); } catch { return {}; } };
    const write = value => { try { localStorage.setItem(key, JSON.stringify(value)); } catch {} };
    let stopped = false;
    let ready = false;
    const previous = read();
    const suppress = this.dataset.subscribed === 'true' || previous.subscribed || Date.now() - (previous.seen || 0) < 7 * 86400000;
    const open = () => {
      if (dialog.open) return;
      write({ ...read(), seen: Date.now() });
      stopped = true;
      dialog.showModal();
    };
    this.querySelector('[data-email-open]').hidden = false;
    this.addEventListener('click', event => {
      if (event.target.closest('[data-email-open]')) open();
      if (event.target.closest('[data-email-close]')) dialog.close();
      if (event.target === dialog) {
        const rect = dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
      }
    }, { signal });
    const result = location.hash === '#SireEmailSignup';
    if (result && this.querySelector('[data-email-success]')) {
      write({ subscribed: true, seen: Date.now() });
      open();
      return;
    }
    if (result && this.querySelector('[data-email-error]')) { open(); return; }
    const maybeOpen = () => {
      if (stopped || suppress || !ready || document.hidden || Number(this.dataset.cartCount) > 0 || window.Shopify?.designMode) return;
      if (document.querySelector('dialog[open], cart-drawer.active, details[open]') || document.activeElement?.matches('input,textarea,select')) return;
      if (window.scrollY < Math.min(600, (document.documentElement.scrollHeight - innerHeight) * .25)) return;
      open();
    };
    document.addEventListener('pointerdown', event => {
      if (event.target.closest('sire-buybox, [data-sire-sticky-for], a[href*="#sire-purchase"], a[href*="/cart"]')) stopped = true;
    }, { signal });
    document.addEventListener('focusin', event => {
      if (event.target.closest('sire-buybox, [data-sire-sticky-for]')) stopped = true;
    }, { signal });
    window.addEventListener('scroll', maybeOpen, { passive:true, signal });
    document.addEventListener('visibilitychange', maybeOpen, { signal });
    this.timer = setTimeout(() => { ready = true; maybeOpen(); }, Number(this.dataset.delay) * 1000);
  }
  disconnectedCallback() { clearTimeout(this.timer); this.controller?.abort(); this.controller = null; }
}
if (!customElements.get('sire-email-popup')) customElements.define('sire-email-popup', SireEmailPopup);
